export default from './CohortSearch';



// WEBPACK FOOTER //
// ./src/pages/cohort_search/index.js